var _ = require('underscore/underscore');
var BasePopup = require('front/components/BasePopup/BasePopup');

var template = require('./BenefitsClassesPopup.jinja');
require('./BenefitsClassesPopup.less');

var CommonStory = require('front/components/CommonStory/CommonStory');
var CommonFooterMembership = require('front/components/CommonFooterMembership/CommonFooterMembership');
var CommonSidebar = require('front/components/CommonSidebar/CommonSidebar');

module.exports = BasePopup.extend({

    template: template,

    events: _.extend({
        // 'click .BenefitsClassesPopup-classSelector': 'toggleYearDropdown'
    }, BasePopup.prototype.baseEvents),

    //Base creates an instances for each one of found dom nodes (by selector) when parent view is rendered itself
    VIEWS_TO_REGISTER: {
        'CommonStory': {selector: '.CommonStory', viewConstructor: CommonStory},
        'CommonFooterMembership': {selector: '.CommonFooterMembership', viewConstructor: CommonFooterMembership},
        'CommonSidebar': {selector: '.CommonSidebar', viewConstructor: CommonSidebar}
    },


    apiUrl: function () {
        return Urls['front:api:benefits_classes-popup']();
    },


    initialize: function (options) {
        this.options = options || {};

        BasePopup.prototype.initialize.call(this, options);
    }

});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/pages/BenefitsClassesPopup/BenefitsClassesPopup.js
// module id = 255
// module chunks = 0